export default __webpack_public_path__ + "static/media/ST1_Grand_mellow.a6217101.png";